import React, { PureComponent } from "react";
import { Icon } from "@vitalsource/vstui";

class NullExploreGraphic extends PureComponent {
  render() {
    return (
      <Icon {...this.props} height={490} width={805}>
        <g
          id="Symbols"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="explore_graphic" transform="translate(1.000000, 0.000000)">
            <g>
              <g id="Group-57" transform="translate(0.000000, 0.848000)">
                <path
                  d="M709.9695,342.2754 L706.8955,342.2754 C707.2205,340.9884 707.4085,339.6424 707.4085,338.2464 C707.4085,329.6844 700.9005,322.7454 692.8705,322.7454 C689.9515,322.7454 687.2405,323.6714 684.9625,325.2494 C682.8805,310.6194 672.8235,299.5204 660.7235,299.5204 C647.7805,299.5204 637.1745,312.2194 636.1675,328.3574 C634.6185,327.3534 632.8855,326.7754 631.0455,326.7754 C624.5865,326.7754 619.3505,333.7144 619.3505,342.2754 L614.4395,342.2754 C606.3865,342.2754 599.7975,349.4464 599.7975,358.2114 L599.7975,359.3824 C599.7975,368.1474 606.3865,375.3184 614.4395,375.3184 L709.9695,375.3184 C718.0225,375.3184 724.6115,368.1474 724.6115,359.3824 L724.6115,358.2114 C724.6115,349.4464 718.0225,342.2754 709.9695,342.2754"
                  id="Fill-1"
                  fill="#ECECEC"
                ></path>
                <path
                  d="M192.8719,307.3262 L188.5869,307.3262 C188.9789,305.5192 189.1929,303.6202 189.1929,301.6572 C189.1929,289.7602 181.4889,280.1152 171.9849,280.1152 C170.5669,280.1152 169.1909,280.3342 167.8729,280.7392 C163.8859,271.5542 156.1109,265.3182 147.1729,265.3182 C137.2089,265.3182 128.6969,273.0702 125.2599,284.0162 C124.7689,283.9752 124.2739,283.9492 123.7729,283.9492 C113.7419,283.9492 105.6099,292.2972 105.6099,302.5942 C105.6099,304.0852 105.7859,305.5322 106.1079,306.9232 C104.8689,306.9412 103.6699,307.0832 102.5229,307.3272 C100.9549,307.3282 99.4889,307.8892 98.2329,308.8442 C94.2409,310.9242 93.1739,314.4832 93.1739,318.5292 C93.1739,324.9452 98.3169,328.1852 114.6139,328.1852 L192.8719,328.1852 C197.4539,328.1852 201.2029,323.4922 201.2029,317.7562 C201.2029,312.0192 197.4539,307.3262 192.8719,307.3262"
                  id="Fill-3"
                  fill="#ECECEC"
                ></path>
                <path
                  d="M575.8719,186.3262 L571.5869,186.3262 C571.9789,184.5192 572.1929,182.6202 572.1929,180.6572 C572.1929,168.7602 564.4889,159.1152 554.9849,159.1152 C553.5669,159.1152 552.1909,159.3342 550.8729,159.7392 C546.8859,150.5542 539.1109,144.3182 530.1729,144.3182 C520.2089,144.3182 511.6969,152.0702 508.2599,163.0162 C507.7689,162.9752 507.2739,162.9492 506.7729,162.9492 C496.7419,162.9492 488.6099,171.2972 488.6099,181.5942 C488.6099,183.0852 488.7859,184.5322 489.1079,185.9232 C487.8689,185.9412 486.6699,186.0832 485.5229,186.3272 C483.9549,186.3282 482.4889,186.8892 481.2329,187.8442 C477.2409,189.9242 476.1739,193.4832 476.1739,197.5292 C476.1739,203.9452 481.3169,207.1852 497.6139,207.1852 L575.8719,207.1852 C580.4539,207.1852 584.2029,202.4922 584.2029,196.7562 C584.2029,191.0192 580.4539,186.3262 575.8719,186.3262"
                  id="Fill-5"
                  fill="#ECECEC"
                ></path>
                <polygon
                  id="Fill-7"
                  fill="#86E0C2"
                  points="90.1815 158.4512 94.8755 163.8132 102.4765 163.1102 98.2245 169.0882 101.0175 175.5202 93.6965 173.8522 87.8215 178.5312 87.5485 171.5232 81.1245 167.9812 88.2785 165.3182"
                ></polygon>
                <polygon
                  id="Fill-9"
                  fill="#86E0C2"
                  points="722.2645 228.4951 725.6115 232.3181 731.0305 231.8171 727.9985 236.0791 729.9905 240.6661 724.7695 239.4761 720.5815 242.8121 720.3865 237.8151 715.8065 235.2911 720.9075 233.3911"
                ></polygon>
                <polygon
                  id="Fill-11"
                  fill="#86E0C2"
                  points="583.0115 383.2471 583.0315 390.5441 589.3725 395.1121 582.0695 396.8691 579.9005 403.7151 575.3665 397.5041 567.6855 397.1661 572.1875 391.5701 569.6085 384.5161 576.9225 387.2691"
                ></polygon>
                <polygon
                  id="Fill-13"
                  fill="#75CFEC"
                  points="342.6297 183.04 347.6047 188.723 355.6597 187.978 351.1527 194.313 354.1137 201.132 346.3537 199.364 340.1277 204.322 339.8377 196.894 333.0287 193.142 340.6107 190.318"
                ></polygon>
                <polygon
                  id="Fill-15"
                  fill="#75CFEC"
                  points="126.5272 365.4238 128.0672 374.0278 136.4982 378.0978 128.2482 381.6878 127.1132 390.2148 120.4742 383.8298 111.3422 385.0288 115.4892 377.4928 110.9802 369.7068 120.1812 371.4348"
                ></polygon>
                <polygon
                  id="Fill-17"
                  fill="#FEC391"
                  points="560.8592 91.3105 565.3962 97.4015 572.8802 97.0875 568.6112 103.3185 571.2632 110.4585 564.0882 108.2185 558.2442 112.9455 558.0782 105.3305 551.8142 101.1105 558.8862 98.6445"
                ></polygon>
                <polygon
                  id="Fill-19"
                  fill="#FEC391"
                  points="718.2342 292.6563 713.2482 298.4323 715.1842 305.7053 708.1442 302.8743 701.7172 307.0303 702.3532 299.5053 696.4442 294.8023 703.8782 292.9813 706.6522 285.9183 710.6112 292.3183"
                ></polygon>
                <path
                  d="M599.8055,14.1514 L599.8055,30.4854"
                  id="Stroke-21"
                  stroke="#DADADA"
                  strokeWidth="2"
                  strokeLinecap="round"
                ></path>
                <path
                  d="M606.6111,22.3184 L593.0001,22.3184"
                  id="Stroke-23"
                  stroke="#DADADA"
                  strokeWidth="2"
                  strokeLinecap="round"
                ></path>
                <path
                  d="M342.8055,0.1514 L342.8055,16.4854"
                  id="Stroke-25"
                  stroke="#DADADA"
                  strokeWidth="2"
                  strokeLinecap="round"
                ></path>
                <path
                  d="M349.6111,8.3184 L336.0001,8.3184"
                  id="Stroke-27"
                  stroke="#DADADA"
                  strokeWidth="2"
                  strokeLinecap="round"
                ></path>
                <path
                  d="M517.8055,299.1514 L517.8055,315.4854"
                  id="Stroke-29"
                  stroke="#DADADA"
                  strokeWidth="2"
                  strokeLinecap="round"
                ></path>
                <path
                  d="M524.6111,307.3184 L511.0001,307.3184"
                  id="Stroke-31"
                  stroke="#DADADA"
                  strokeWidth="2"
                  strokeLinecap="round"
                ></path>
                <path
                  d="M798.8055,261.1514 L798.8055,277.4854"
                  id="Stroke-33"
                  stroke="#DADADA"
                  strokeWidth="2"
                  strokeLinecap="round"
                ></path>
                <path
                  d="M805.6111,269.3184 L792.0001,269.3184"
                  id="Stroke-35"
                  stroke="#DADADA"
                  strokeWidth="2"
                  strokeLinecap="round"
                ></path>
                <path
                  d="M205.8055,77.1514 L205.8055,93.4854"
                  id="Stroke-37"
                  stroke="#DADADA"
                  strokeWidth="2"
                  strokeLinecap="round"
                ></path>
                <path
                  d="M212.6112,85.3184 L199.0002,85.3184"
                  id="Stroke-39"
                  stroke="#DADADA"
                  strokeWidth="2"
                  strokeLinecap="round"
                ></path>
                <path
                  d="M296.6111,341.9854 L296.6111,358.3184"
                  id="Stroke-41"
                  stroke="#DADADA"
                  strokeWidth="2"
                  strokeLinecap="round"
                ></path>
                <path
                  d="M303.4168,350.1514 L289.8058,350.1514"
                  id="Stroke-43"
                  stroke="#DADADA"
                  strokeWidth="2"
                  strokeLinecap="round"
                ></path>
                <path
                  d="M6.8055,295.4854 L6.8055,311.8184"
                  id="Stroke-45"
                  stroke="#DADADA"
                  strokeWidth="2"
                  strokeLinecap="round"
                ></path>
                <path
                  d="M13.6112,303.6514 L0.0002,303.6514"
                  id="Stroke-47"
                  stroke="#DADADA"
                  strokeWidth="2"
                  strokeLinecap="round"
                ></path>
                <path
                  d="M97.45,238.8086 C99.054,233.7236 97.859,227.9446 93.848,223.8916 C88.082,218.0656 78.683,218.0166 72.857,223.7836 C70.637,225.9806 69.258,228.7066 68.718,231.5606 C68.471,232.8636 68.401,234.1926 68.505,235.5096 C68.771,238.8816 70.183,242.1816 72.749,244.7736 C78.515,250.6006 87.913,250.6486 93.739,244.8826 C93.963,244.6616 94.175,244.4336 94.382,244.2026 C95.814,242.5956 96.837,240.7536 97.45,238.8086"
                  id="Fill-49"
                  fill="#FEDBBD"
                ></path>
                <path
                  d="M677.742,175.583 C676.955,169.009 672.647,163.079 666.035,160.545 C656.528,156.9 645.868,161.653 642.223,171.16 C640.835,174.783 640.669,178.573 641.518,182.079 C641.905,183.68 642.505,185.22 643.298,186.658 C645.324,190.338 648.609,193.35 652.839,194.971 C662.346,198.615 673.007,193.862 676.65,184.355 C676.79,183.991 676.913,183.624 677.028,183.257 C677.828,180.707 678.043,178.098 677.742,175.583"
                  id="Fill-51"
                  fill="#B0E3F4"
                ></path>
                <path
                  d="M709.1932,170.1113 C708.3352,164.7733 687.4712,166.1483 675.1122,167.4433 L674.1222,167.5483 L675.4582,170.0713 L675.9102,170.0233 C698.9812,167.6033 704.9712,169.6333 705.2502,170.5333 C705.2522,170.5553 705.2892,172.8253 694.0742,176.3513 C685.1872,179.1433 673.1872,181.8253 660.2872,183.9003 C647.3852,185.9753 635.1502,187.1923 625.8382,187.3273 C614.5852,187.5083 613.9442,185.5073 613.9092,185.2823 C613.9032,185.2453 614.7052,181.3423 641.3922,175.5433 L641.8382,175.4473 L642.3052,172.6563 L641.3352,172.8673 C629.0862,175.5283 608.6642,180.7923 609.5252,186.1433 C609.9552,188.8113 614.4442,190.0023 624.0842,190.0023 C624.6622,190.0023 625.2592,189.9963 625.8762,189.9883 C635.3202,189.8513 647.6912,188.6223 660.7102,186.5273 C673.7342,184.4323 685.8662,181.7193 694.8742,178.8883 C705.2282,175.6333 709.6442,172.9263 709.1932,170.1113"
                  id="Fill-53"
                  fill="#86E0C2"
                ></path>
                <path
                  d="M98.2869,231.7588 L97.2219,231.4068 L97.3959,234.1658 L97.8819,234.3268 C114.8919,239.9648 118.9589,243.3938 119.1039,244.1528 C119.0959,244.1678 118.2169,245.6578 109.2039,244.5738 C101.7659,243.6778 92.0849,241.6668 81.9419,238.9128 C71.7959,236.1598 62.4269,232.9988 55.5589,230.0118 C47.4899,226.5018 47.5989,224.8588 47.5859,224.8588 C47.6279,224.8158 50.1219,222.5278 70.7489,226.9348 L71.2499,227.0408 L72.7769,224.7628 L71.6829,224.5298 C49.6789,219.8288 44.3119,221.5798 43.6879,223.8758 C43.0839,226.0988 46.0209,228.5378 53.2099,231.7878 C53.6379,231.9808 54.0769,232.1758 54.5319,232.3738 C61.5179,235.4098 71.0139,238.6158 81.2669,241.3978 C91.5269,244.1838 101.3389,246.2188 108.8969,247.1288 C111.7909,247.4778 114.1759,247.6568 116.0989,247.6568 C120.1069,247.6568 122.1129,246.8848 122.5479,245.2808 C123.1709,242.9868 119.4679,238.7798 98.2869,231.7588"
                  id="Fill-55"
                  fill="#B0E3F4"
                ></path>
              </g>
              <g id="Group-130" transform="translate(29.000000, 39.848000)">
                <g
                  id="Group-60"
                  transform="translate(468.000000, 359.000000)"
                  fill="#C0EADB"
                >
                  <path
                    d="M58.8904,30.6523 L38.2454,30.6523 C37.6194,30.6523 37.1114,30.1433 37.1114,29.5173 L37.1114,27.8183 C37.1114,27.1913 37.6194,26.6833 38.2454,26.6833 L55.8454,26.6833 L52.3434,22.1203 L31.4114,22.1203 C30.7864,22.1203 30.2774,21.6113 30.2774,20.9853 L30.2774,19.2873 C30.2774,18.6603 30.7864,18.1523 31.4114,18.1523 L49.2974,18.1523 L35.6114,0.3183 L0.5524,46.0003 L70.6694,46.0003 L58.8904,30.6523 Z"
                    id="Fill-58"
                  ></path>
                </g>
                <path
                  d="M498.2772,378.2871 L498.2772,379.9851 C498.2772,380.6111 498.7862,381.1201 499.4122,381.1201 L520.3432,381.1201 L517.2982,377.1521 L499.4122,377.1521 C498.7862,377.1521 498.2772,377.6601 498.2772,378.2871"
                  id="Fill-61"
                  fill="#86E0C2"
                ></path>
                <path
                  d="M505.1111,386.8184 L505.1111,388.5174 C505.1111,389.1434 505.6191,389.6524 506.2461,389.6524 L526.8901,389.6524 L523.8451,385.6834 L506.2461,385.6834 C505.6191,385.6834 505.1111,386.1914 505.1111,386.8184"
                  id="Fill-63"
                  fill="#86E0C2"
                ></path>
                <path
                  d="M215.5272,307.3887 L131.9352,307.3887 C129.8022,307.3887 128.0732,305.6597 128.0732,303.5277 L128.0732,199.7197 C128.0732,197.5867 129.8022,195.8587 131.9352,195.8587 L215.5272,195.8587 C217.6602,195.8587 219.3882,197.5867 219.3882,199.7197 L219.3882,303.5277 C219.3882,305.6597 217.6602,307.3887 215.5272,307.3887"
                  id="Fill-65"
                  fill="#FE9840"
                ></path>
                <path
                  d="M199.3817,279.8496 L148.0797,279.8496 C145.9467,279.8496 144.2187,278.1206 144.2187,275.9886 L144.2187,258.5116 C144.2187,256.3786 145.9467,254.6506 148.0797,254.6506 L199.3817,254.6506 C201.5147,254.6506 203.2427,256.3786 203.2427,258.5116 L203.2427,275.9886 C203.2427,278.1206 201.5147,279.8496 199.3817,279.8496"
                  id="Fill-67"
                  fill="#FEC391"
                ></path>
                <path
                  d="M199.3817,235.3369 L148.0797,235.3369 C145.9467,235.3369 144.2187,237.0659 144.2187,239.1979 L144.2187,240.4439 C144.2187,242.5769 145.9467,244.3059 148.0797,244.3059 L199.3817,244.3059 C201.5147,244.3059 203.2427,242.5769 203.2427,240.4439 L203.2427,239.1979 C203.2427,237.0659 201.5147,235.3369 199.3817,235.3369"
                  id="Fill-69"
                  fill="#FEC391"
                ></path>
                <path
                  d="M493.6248,197.5518 L420.6088,197.5518 C418.3978,197.5518 416.6048,195.7598 416.6048,193.5488 L416.6048,94.7098 C416.6048,92.4988 418.3978,90.7058 420.6088,90.7058 L493.6248,90.7058 C495.8358,90.7058 497.6288,92.4988 497.6288,94.7098 L497.6288,193.5488 C497.6288,195.7598 495.8358,197.5518 493.6248,197.5518"
                  id="Fill-71"
                  fill="#23C991"
                ></path>
                <path
                  d="M478.0594,177.0381 L436.1744,177.0381 C433.9634,177.0381 432.1714,175.2451 432.1714,173.0341 L432.1714,111.7471 C432.1714,109.5351 433.9634,107.7431 436.1744,107.7431 L478.0594,107.7431 C480.2704,107.7431 482.0624,109.5351 482.0624,111.7471 L482.0624,173.0341 C482.0624,175.2451 480.2704,177.0381 478.0594,177.0381"
                  id="Fill-73"
                  fill="#86E0C2"
                ></path>
                <path
                  d="M276.3787,254.3359 L190.9857,254.3359 C188.8537,254.3359 187.1247,252.6069 187.1247,250.4749 L187.1247,123.1799 C187.1247,121.0469 188.8537,119.3179 190.9857,119.3179 L276.3787,119.3179 C278.5117,119.3179 280.2397,121.0469 280.2397,123.1799 L280.2397,250.4749 C280.2397,252.6069 278.5117,254.3359 276.3787,254.3359"
                  id="Fill-75"
                  fill="#00A7DB"
                ></path>
                <path
                  d="M263.8797,226.4014 L203.4847,226.4014 C201.3527,226.4014 199.6237,224.6724 199.6237,222.5394 L199.6237,140.1254 C199.6237,137.9924 201.3527,136.2634 203.4847,136.2634 L263.8797,136.2634 C266.0127,136.2634 267.7407,137.9924 267.7407,140.1254 L267.7407,222.5394 C267.7407,224.6724 266.0127,226.4014 263.8797,226.4014"
                  id="Fill-77"
                  fill="#75CFEC"
                ></path>
                <path
                  d="M614.1277,315.5752 L531.4527,315.5752 C529.3307,315.5752 527.6107,313.8552 527.6107,311.7332 L527.6107,190.7512 C527.6107,188.6302 529.3307,186.9102 531.4527,186.9102 L614.1277,186.9102 C616.2487,186.9102 617.9687,188.6302 617.9687,190.7512 L617.9687,311.7332 C617.9687,313.8552 616.2487,315.5752 614.1277,315.5752"
                  id="Fill-79"
                  fill="#00A7DB"
                ></path>
                <path
                  d="M601.1121,297.2168 L544.4671,297.2168 C542.3461,297.2168 540.6271,295.4968 540.6271,293.3758 L540.6271,240.7518 C540.6271,238.6308 542.3461,236.9108 544.4671,236.9108 L601.1121,236.9108 C603.2331,236.9108 604.9531,238.6308 604.9531,240.7518 L604.9531,293.3758 C604.9531,295.4968 603.2331,297.2168 601.1121,297.2168"
                  id="Fill-81"
                  fill="#75CFEC"
                ></path>
                <path
                  d="M601.1121,225.4326 L544.4671,225.4326 C542.3461,225.4326 540.6271,223.7126 540.6271,221.5906 L540.6271,221.4646 C540.6271,219.3436 542.3461,217.6236 544.4671,217.6236 L601.1121,217.6236 C603.2331,217.6236 604.9531,219.3436 604.9531,221.4646 L604.9531,221.5906 C604.9531,223.7126 603.2331,225.4326 601.1121,225.4326"
                  id="Fill-83"
                  fill="#75CFEC"
                ></path>
                <path
                  d="M441.1522,154.4248 L359.2872,154.4248 C357.0762,154.4248 355.2842,152.6328 355.2842,150.4218 L355.2842,31.3218 C355.2842,29.1108 357.0762,27.3188 359.2872,27.3188 L441.1522,27.3188 C443.3632,27.3188 445.1562,29.1108 445.1562,31.3218 L445.1562,150.4218 C445.1562,152.6328 443.3632,154.4248 441.1522,154.4248"
                  id="Fill-85"
                  fill="#FE9840"
                ></path>
                <path
                  d="M426.8123,114.3965 L373.6263,114.3965 C371.4153,114.3965 369.6233,112.6045 369.6233,110.3935 L369.6233,44.5145 C369.6233,42.3035 371.4153,40.5105 373.6263,40.5105 L426.8123,40.5105 C429.0243,40.5105 430.8163,42.3035 430.8163,44.5145 L430.8163,110.3935 C430.8163,112.6045 429.0243,114.3965 426.8123,114.3965"
                  id="Fill-87"
                  fill="#FEC391"
                ></path>
                <path
                  d="M426.8123,126.1699 L373.6263,126.1699 C371.4153,126.1699 369.6233,127.9619 369.6233,130.1729 L369.6233,131.4649 C369.6233,133.6759 371.4153,135.4689 373.6263,135.4689 L426.8123,135.4689 C429.0243,135.4689 430.8163,133.6759 430.8163,131.4649 L430.8163,130.1729 C430.8163,127.9619 429.0243,126.1699 426.8123,126.1699"
                  id="Fill-89"
                  fill="#FEC391"
                ></path>
                <path
                  d="M398.5447,364.3184 L316.7997,364.3184 C314.3937,364.3184 312.4427,362.3684 312.4427,359.9624 L312.4427,237.6744 C312.4427,235.2684 314.3937,233.3184 316.7997,233.3184 L398.5447,233.3184 C400.9507,233.3184 402.9007,235.2684 402.9007,237.6744 L402.9007,359.9624 C402.9007,362.3684 400.9507,364.3184 398.5447,364.3184"
                  id="Fill-91"
                  fill="#23C991"
                ></path>
                <path
                  d="M381.1658,306.4951 L334.1788,306.4951 C331.7718,306.4951 329.8208,304.5451 329.8208,302.1391 L329.8208,254.2051 C329.8208,251.7991 331.7718,249.8491 334.1788,249.8491 L381.1658,249.8491 C383.5718,249.8491 385.5228,251.7991 385.5228,254.2051 L385.5228,302.1391 C385.5228,304.5451 383.5718,306.4951 381.1658,306.4951"
                  id="Fill-93"
                  fill="#86E0C2"
                ></path>
                <path
                  d="M381.2762,351.0244 L334.0682,351.0244 C331.7222,351.0244 329.8212,349.1234 329.8212,346.7774 C329.8212,344.4314 331.7222,342.5304 334.0682,342.5304 L381.2762,342.5304 C383.6222,342.5304 385.5232,344.4314 385.5232,346.7774 C385.5232,349.1234 383.6222,351.0244 381.2762,351.0244"
                  id="Fill-95"
                  fill="#86E0C2"
                ></path>
                <path
                  d="M381.1658,336.3301 L334.1788,336.3301 C331.7718,336.3301 329.8208,334.3801 329.8208,331.9741 L329.8208,325.1261 C329.8208,322.7201 331.7718,320.7691 334.1788,320.7691 L381.1658,320.7691 C383.5718,320.7691 385.5228,322.7201 385.5228,325.1261 L385.5228,331.9741 C385.5228,334.3801 383.5718,336.3301 381.1658,336.3301"
                  id="Fill-97"
                  fill="#86E0C2"
                ></path>
                <g
                  id="Group-101"
                  transform="translate(409.000000, 347.000000)"
                  fill="#B0E3F4"
                >
                  <path
                    d="M75.3299,40.6523 L47.2459,40.6523 C46.6189,40.6523 46.1109,40.1433 46.1109,39.5173 L46.1109,37.8183 C46.1109,37.1913 46.6189,36.6833 47.2459,36.6833 L72.2839,36.6833 L67.2469,30.1203 L40.4119,30.1203 C39.7859,30.1203 39.2769,29.6113 39.2769,28.9853 L39.2769,27.2873 C39.2769,26.6603 39.7859,26.1523 40.4119,26.1523 L64.2009,26.1523 L44.6109,0.6253 L0.5789,58.0003 L88.6429,58.0003 L75.3299,40.6523 Z"
                    id="Fill-99"
                  ></path>
                </g>
                <path
                  d="M448.2772,374.2871 L448.2772,375.9851 C448.2772,376.6111 448.7862,377.1201 449.4122,377.1201 L476.2472,377.1201 L473.2012,373.1521 L449.4122,373.1521 C448.7862,373.1521 448.2772,373.6601 448.2772,374.2871"
                  id="Fill-102"
                  fill="#75CFEC"
                ></path>
                <path
                  d="M455.1111,384.8184 L455.1111,386.5174 C455.1111,387.1434 455.6191,387.6524 456.2461,387.6524 L484.3301,387.6524 L481.2841,383.6834 L456.2461,383.6834 C455.6191,383.6834 455.1111,384.1914 455.1111,384.8184"
                  id="Fill-104"
                  fill="#75CFEC"
                ></path>
                <path
                  d="M278.6053,390.8848 L255.7543,390.8848 C255.2453,390.8848 254.8323,390.4718 254.8323,389.9618 L254.8323,388.5798 C254.8323,388.0698 255.2453,387.6558 255.7543,387.6558 L276.1263,387.6558 L272.0283,382.3168 L250.1953,382.3168 C249.6853,382.3168 249.2713,381.9028 249.2713,381.3928 L249.2713,380.0108 C249.2713,379.5008 249.6853,379.0868 250.1953,379.0868 L269.5503,379.0868 L253.6113,358.3188 L217.7853,404.9998 L289.4373,404.9998 L278.6053,390.8848 Z"
                  id="Fill-106"
                  fill="#B0E3F4"
                ></path>
                <path
                  d="M249.2713,380.0107 L249.2713,381.3927 C249.2713,381.9027 249.6853,382.3167 250.1953,382.3167 L272.0283,382.3167 L269.5503,379.0867 L250.1953,379.0867 C249.6853,379.0867 249.2713,379.5007 249.2713,380.0107"
                  id="Fill-108"
                  fill="#75CFEC"
                ></path>
                <path
                  d="M254.8318,388.5801 L254.8318,389.9621 C254.8318,390.4721 255.2448,390.8851 255.7548,390.8851 L278.6048,390.8851 L276.1268,387.6561 L255.7548,387.6561 C255.2448,387.6561 254.8318,388.0691 254.8318,388.5801"
                  id="Fill-110"
                  fill="#75CFEC"
                ></path>
                <path
                  d="M215.7,72.3184 C215.7,74.5764 213.869,76.4074 211.611,76.4074 C209.353,76.4074 207.522,74.5764 207.522,72.3184 C207.522,70.0604 209.353,68.2294 211.611,68.2294 C213.869,68.2294 215.7,70.0604 215.7,72.3184"
                  id="Fill-112"
                  fill="#86E0C2"
                ></path>
                <path
                  d="M575.7,36.3184 C575.7,38.5764 573.869,40.4074 571.611,40.4074 C569.353,40.4074 567.522,38.5764 567.522,36.3184 C567.522,34.0604 569.353,32.2294 571.611,32.2294 C573.869,32.2294 575.7,34.0604 575.7,36.3184"
                  id="Fill-114"
                  fill="#86E0C2"
                ></path>
                <path
                  d="M19.2801,241.6514 C19.2801,243.8624 17.4881,245.6544 15.2781,245.6544 C13.0671,245.6544 11.2751,243.8624 11.2751,241.6514 C11.2751,239.4414 13.0671,237.6494 15.2781,237.6494 C17.4881,237.6494 19.2801,239.4414 19.2801,241.6514"
                  id="Fill-116"
                  fill="#75CFEC"
                ></path>
                <path
                  d="M717.6141,248.3184 C717.6141,250.5294 715.8221,252.3214 713.6111,252.3214 C711.4001,252.3214 709.6081,250.5294 709.6081,248.3184 C709.6081,246.1074 711.4001,244.3154 713.6111,244.3154 C715.8221,244.3154 717.6141,246.1074 717.6141,248.3184"
                  id="Fill-118"
                  fill="#75CFEC"
                ></path>
                <path
                  d="M523.616,4.3184 C523.616,6.5294 521.824,8.3214 519.614,8.3214 C517.403,8.3214 515.611,6.5294 515.611,4.3184 C515.611,2.1074 517.403,0.3154 519.614,0.3154 C521.824,0.3154 523.616,2.1074 523.616,4.3184"
                  id="Fill-120"
                  fill="#75CFEC"
                ></path>
                <path
                  d="M7.2782,285.6514 C7.2782,287.6024 5.6962,289.1844 3.7452,289.1844 C1.7952,289.1844 0.2132,287.6024 0.2132,285.6514 C0.2132,283.7014 1.7952,282.1194 3.7452,282.1194 C5.6962,282.1194 7.2782,283.7014 7.2782,285.6514"
                  id="Fill-122"
                  fill="#FEC391"
                ></path>
                <path
                  d="M135.2782,361.6514 C135.2782,363.6024 133.6962,365.1844 131.7452,365.1844 C129.7952,365.1844 128.2132,363.6024 128.2132,361.6514 C128.2132,359.7014 129.7952,358.1194 131.7452,358.1194 C133.6962,358.1194 135.2782,359.7014 135.2782,361.6514"
                  id="Fill-124"
                  fill="#86E0C2"
                ></path>
                <path
                  d="M339.7977,187.3184 C339.7977,189.0784 338.3707,190.5054 336.6107,190.5054 C334.8517,190.5054 333.4247,189.0784 333.4247,187.3184 C333.4247,185.5584 334.8517,184.1314 336.6107,184.1314 C338.3707,184.1314 339.7977,185.5584 339.7977,187.3184"
                  id="Fill-126"
                  fill="#FEC391"
                ></path>
                <path
                  d="M468.7977,291.3184 C468.7977,293.0784 467.3707,294.5054 465.6107,294.5054 C463.8517,294.5054 462.4247,293.0784 462.4247,291.3184 C462.4247,289.5584 463.8517,288.1314 465.6107,288.1314 C467.3707,288.1314 468.7977,289.5584 468.7977,291.3184"
                  id="Fill-128"
                  fill="#FEC391"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </Icon>
    );
  }
}

NullExploreGraphic.displayName = "NullExploreGraphic";
NullExploreGraphic.vstuiName = "Icon";

export default NullExploreGraphic;
